
define('text!modules/feedback/en/feedback-button.html',[],function () { return '<div id="feedbackTab">\n<a href="#"><span>Feedback</span></a>\n</div>';});

